__turbopack_context__.v({
  "CardPriceTag": "ProductCard-module__g-pugq__CardPriceTag",
  "CardReviewText": "ProductCard-module__g-pugq__CardReviewText",
  "DiscountTag": "ProductCard-module__g-pugq__DiscountTag",
  "ProductCard": "ProductCard-module__g-pugq__ProductCard",
  "active": "ProductCard-module__g-pugq__active",
  "addToCartBtn": "ProductCard-module__g-pugq__addToCartBtn",
  "attribute": "ProductCard-module__g-pugq__attribute",
  "attributes": "ProductCard-module__g-pugq__attributes",
  "badge": "ProductCard-module__g-pugq__badge",
  "badgeHot": "ProductCard-module__g-pugq__badgeHot",
  "badgeIcon": "ProductCard-module__g-pugq__badgeIcon",
  "badgeSale": "ProductCard-module__g-pugq__badgeSale",
  "badgeText": "ProductCard-module__g-pugq__badgeText",
  "brandButton": "ProductCard-module__g-pugq__brandButton",
  "button": "ProductCard-module__g-pugq__button",
  "buttons": "ProductCard-module__g-pugq__buttons",
  "buttonsContainer": "ProductCard-module__g-pugq__buttonsContainer",
  "cardBody": "ProductCard-module__g-pugq__cardBody",
  "cardButton": "ProductCard-module__g-pugq__cardButton",
  "cardImage": "ProductCard-module__g-pugq__cardImage",
  "cardPriceTag": "ProductCard-module__g-pugq__cardPriceTag",
  "cardReviewText": "ProductCard-module__g-pugq__cardReviewText",
  "cardTextContents": "ProductCard-module__g-pugq__cardTextContents",
  "cardTitle": "ProductCard-module__g-pugq__cardTitle",
  "cardTop": "ProductCard-module__g-pugq__cardTop",
  "cart": "ProductCard-module__g-pugq__cart",
  "comingSoon": "ProductCard-module__g-pugq__comingSoon",
  "count": "ProductCard-module__g-pugq__count",
  "discountTag": "ProductCard-module__g-pugq__discountTag",
  "freeDeliveryTag": "ProductCard-module__g-pugq__freeDeliveryTag",
  "full": "ProductCard-module__g-pugq__full",
  "higherQuantity": "ProductCard-module__g-pugq__higherQuantity",
  "icon": "ProductCard-module__g-pugq__icon",
  "image": "ProductCard-module__g-pugq__image",
  "lg": "ProductCard-module__g-pugq__lg",
  "lg2": "ProductCard-module__g-pugq__lg2",
  "loading": "ProductCard-module__g-pugq__loading",
  "md": "ProductCard-module__g-pugq__md",
  "message": "ProductCard-module__g-pugq__message",
  "outOfStock": "ProductCard-module__g-pugq__outOfStock",
  "outOfStockText": "ProductCard-module__g-pugq__outOfStockText",
  "overlay": "ProductCard-module__g-pugq__overlay",
  "popIn": "ProductCard-module__g-pugq__popIn",
  "popOut": "ProductCard-module__g-pugq__popOut",
  "preOrderText": "ProductCard-module__g-pugq__preOrderText",
  "prePrice": "ProductCard-module__g-pugq__prePrice",
  "price": "ProductCard-module__g-pugq__price",
  "quantityBtn": "ProductCard-module__g-pugq__quantityBtn",
  "rating": "ProductCard-module__g-pugq__rating",
  "removeBtn": "ProductCard-module__g-pugq__removeBtn",
  "removeButton": "ProductCard-module__g-pugq__removeButton",
  "reverse": "ProductCard-module__g-pugq__reverse",
  "sm": "ProductCard-module__g-pugq__sm",
  "spin": "ProductCard-module__g-pugq__spin",
  "top": "ProductCard-module__g-pugq__top",
  "wishlist": "ProductCard-module__g-pugq__wishlist",
  "xl": "ProductCard-module__g-pugq__xl",
  "xs": "ProductCard-module__g-pugq__xs",
});
